<template>
  <div>
    <p class="title is-4">General Settings</p>
    <div class="field">
      <label class="label" for="meeting-name">Meeting Name</label>
      <p class="help">
        You can change the meeting name from its original MatrixMaxx meeting
        name here. Note that the changes will immediately show for all users.
      </p>
      <div class="control">
        <input
          type="text"
          class="input"
          v-model="newMeetingName"
          name="meeting-name"
          id="meeting-name"
        />
      </div>
    </div>
    <div class="field">
      <label for="meeting-timezone" class="label">Meeting Timezone</label>
      <p class="help">
        The timezone will show on the schedule and user suites pages and will be
        used for calendar exports. Meetings with no setting here are assumed to
        be Eastern time.
      </p>
      <div class="select">
        <select
          name="meeting-timezone"
          id="meeting-timezone"
          v-model="newMeetingTimezone"
        >
          <option value="">Select a timezone</option>
          <option value="US/Eastern">Eastern</option>
          <option value="US/Central">Central</option>
          <option value="US/Mountain">Mountain</option>
          <option value="US/Pacific">Pacific</option>
        </select>
      </div>
    </div>
    <p v-if="updateStatus" class="mb-4">
      <strong>{{ updateStatus }}</strong>
    </p>
    <button
      class="button is-success"
      @click="updateSettings()"
      :class="{ 'is-loading': loading }"
    >
      Save
    </button>
  </div>
</template>

<script>
import { updateMeetingSettings, db } from '@/services/firebase';
// TODO: update text about where timezone will display

export default {
  data() {
    return {
      meeting: {},
      newMeetingName: '',
      newMeetingTimezone: '',
      updateStatus: '',
      loading: false
    };
  },
  computed: {
    meetingId() {
      return this.$route.params.id;
    }
  },
  watch: {
    meeting(newValue, oldValue) {
      if (oldValue.maxxId !== newValue.maxxId) {
        this.newMeetingTimezone = newValue.timezone ? newValue.timezone : '';
      }
    }
  },
  methods: {
    async updateSettings() {
      this.loading = true;
      await updateMeetingSettings({
        meetingId: this.meetingId,
        name: this.newMeetingName,
        timezone: this.newMeetingTimezone
      });
      this.loading = false;
      this.updateStatus = 'Your changes have been saved.';
      this.newMeetingName = '';
    }
  },
  firestore() {
    return {
      meeting: db.collection('meetings').doc(this.meetingId)
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/meeting/MeetingSettings.vue